/* eslint-disable max-lines */
import { transport, act } from 'api';
import {
  SET_TRANSPORT_PROPERTY,
  TRANSPORT_GET_MASTER_DATA,
  TRANSPORT_UPDATE_MASTER_DATA,
  TRANSPORT_GET_LIST,
  TRANSPORT_EMPLOYEES_GET_LIST,
  TRANSPORT_GET_DRIVERS,
  TRANSPORT_SET_DRIVER,
  TRANSPORT_LOGISTIC_DRIVER_GET_LIST,
  TRANSPORT_GET_ACT,
  TRANSPORT_ACCEPT,
  TRANSPORT_DENY,
  TRANSPORT_REJECT,
  CANCEL_MANAGEMENT,
  ACT_SAVE_DATA_TRANSFER,
  ACT_SAVE_DATA,
  GET_REQUIRED_DOCUMENTATION,
  UI_UPDATE_FROM_PARTNER,
  VALIDATE_DOCUMENT,
  CANCEL_ACT,
  CANCEL_ACT_TRANSFER,
  GET_REQUIRED_DOCUMENTATION_OFFLINE,
  GET_REQUIRED_IMAGES_OFFLINE,
  UPDATE_RISK_OFFLINE,
  GET_ID_TRANSACTION_OFFLINE,
  SAVE_DOCUMENTS_OFFLINE,
  GET_OFFLINE_PRINT
} from 'store/actions/transport';
import { lsSetAct, lsSetTransferAct } from 'helpers/store';
import { userProfile, userPartnerId } from 'helpers/user';
import { setCurrentDateTimeIfNull } from 'helpers/date';
import { ensureTyreProperties } from 'helpers/object';
import { TYPE_CHECK } from 'store/enums';

export default {
  [SET_TRANSPORT_PROPERTY]: ({ commit }, { field, value }) =>
    commit(SET_TRANSPORT_PROPERTY, { field, value }),

  [TRANSPORT_GET_MASTER_DATA]: ({ commit, getters }) =>
    new Promise((resolve, reject) => {
      if (!getters.hasTransportMasterData) {
        transport
          .getMasterData()
          .then(resp => {
            commit(TRANSPORT_UPDATE_MASTER_DATA, resp.data);
            resolve();
          })
          .catch(err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          });
      } else {
        resolve();
      }
    }),

  [TRANSPORT_GET_LIST]: ({ state, commit }) =>
    new Promise((resolve, reject) => {
      userPartnerId()
        .then(partnerid => {
          const idProvider = partnerid || null;
          if (idProvider) {
            const filters = {
              idProvider,
              plate: state.filtersManagerTransportList.plate,
              idState: state.filtersManagerTransportList.idState,
              idType: state.filtersManagerTransportList.idType
            };
            transport.getTransportationList(filters).then(
              resp => {
                commit(SET_TRANSPORT_PROPERTY, {
                  field: 'managerTransportList',
                  value: resp.data
                });
                resolve();
              },
              err => {
                // commit('ERROR_OCCURRED', err, { root: true });
                reject(err.response.data.error);
              }
            );
          } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject(
              'Debe tener un partnerid asociado en su perfil de usuario para obtener el listado.'
            );
          }
        })
        .catch(err => {
          reject(err.response.data.error);
        });
    }),

  [TRANSPORT_EMPLOYEES_GET_LIST]: ({ state, commit }) =>
    new Promise((resolve, reject) => {
      const filters = {
        idProvider: state.filterEmployeesTransportList.idProvider,
        plate: state.filterEmployeesTransportList.plate,
        idState: state.filterEmployeesTransportList.idState,
        idType: state.filterEmployeesTransportList.idType
      };
      transport.getTransportationList(filters).then(
        resp => {
          commit(SET_TRANSPORT_PROPERTY, {
            field: 'employeesTransportList',
            value: resp.data
          });
          resolve();
        },
        err => {
          // commit('ERROR_OCCURRED', err, { root: true });
          reject(err.response.data.error);
        }
      );
    }),

  [TRANSPORT_LOGISTIC_DRIVER_GET_LIST]: ({ state, commit }) =>
    new Promise((resolve, reject) => {
      userProfile()
        .then(profile => {
          const idUserWebDriver = profile.id || null;
          if (idUserWebDriver) {
            const filters = {
              idUserWebDriver,
              plate: state.filterDriverTransportList.plate,
              idState: state.filterDriverTransportList.idState,
              idType: state.filterDriverTransportList.idType
            };
            transport.getTransportationList(filters).then(
              resp => {
                commit(SET_TRANSPORT_PROPERTY, {
                  field: 'driverLogisticTransportList',
                  value: resp.data
                });
                resolve();
              },
              err => {
                // commit('ERROR_OCCURRED', err, { root: true });
                reject(err.response.data.error);
              }
            );
          } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject('Error al obtener el id del conductor');
          }
        })
        .catch(err => {
          reject(err.response.data.error);
        });
    }),

  [TRANSPORT_GET_DRIVERS]: ({ commit }, idTransport) =>
    new Promise((resolve, reject) => {
      transport.getTransportDrivers(idTransport).then(
        resp => {
          commit(TRANSPORT_GET_DRIVERS, resp.data);
          resolve();
        },
        err => {
          reject(err.response.data.error);
        }
      );
    }),

  [TRANSPORT_SET_DRIVER]: (_, { idTransport, idDriver }) =>
    new Promise((resolve, reject) => {
      userProfile()
        .then(profile => {
          transport
            .setDriver({
              idTransport: parseInt(idTransport, 10),
              idDriver: parseInt(idDriver, 10),
              mailUser: profile?.email ?? null,
              idUser: profile?.id ?? null,
              idPartner: profile?.partnerid ?? null
            })
            .then(
              () => {
                resolve();
              },
              err => {
                reject(err.response.data.error);
              }
            );
        })
        .catch(err => {
          reject(err.response.data.error);
        });
    }),

  [TRANSPORT_GET_ACT]: ({ commit }, { plate, idDocumentType }) =>
    new Promise((resolve, reject) => {
      const LS_ACTS = {
        getAct: lsSetAct,
        getTransferAct: lsSetTransferAct
      };
      userProfile()
        .then(profile => {
          const filters = {
            plate,
            mailUser: profile?.email ?? null,
            idUser: profile?.id ?? null,
            idPartner: profile?.partnerid ?? null
          };
          const isClientAct =
            idDocumentType === TYPE_CHECK.CHECK_IN || idDocumentType === TYPE_CHECK.CHECK_OUT;
          const callAct = isClientAct ? 'getAct' : 'getTransferAct';
          act[callAct](filters).then(
            resp => {
              const actData = ensureTyreProperties({
                data: setCurrentDateTimeIfNull({
                  data: resp.data,
                  prop: 'variable.date'
                })
              });
              LS_ACTS[callAct](actData);
              commit(SET_TRANSPORT_PROPERTY, {
                field: 'act',
                value: actData
              });
              resolve({
                redirectToRouteName: isClientAct ? 'transport-act-client' : 'transport-act-transfer'
              });
            },
            err => {
              // commit('ERROR_OCCURRED', err, { root: true });
              reject(err.response.data.error);
            }
          );
        })
        .catch(err => {
          reject(err.response.data.error);
        });
    }),

  [TRANSPORT_ACCEPT]: (_, data) =>
    new Promise((resolve, reject) => {
      userProfile()
        .then(profile => {
          const userInfo = {
            mailUser: profile?.email ?? null,
            idUser: profile?.id ?? null,
            idPartner: profile?.partnerid ?? null
          };
          const isUnassign = data.idReasonRejection;
          const dataTransport = isUnassign ? data : { idTransport: data.idTransport };
          const dataToSend = { ...dataTransport, ...userInfo };
          transport.transportAccept(dataToSend).then(
            () => {
              resolve();
            },
            err => {
              reject(err.response.data.error);
            }
          );
        })
        .catch(err => {
          reject(err.response.data.error);
        });
    }),

  [TRANSPORT_DENY]: (_, data) =>
    new Promise((resolve, reject) => {
      userProfile()
        .then(profile => {
          const userInfo = {
            mailUser: profile?.email ?? null,
            idUser: profile?.id ?? null,
            idPartner: profile?.partnerid ?? null
          };
          const dataToSend = { ...data, ...userInfo };
          transport.transportDeny(dataToSend).then(
            resp => {
              resolve(resp.data);
            },
            err => {
              reject(err.response.data.error);
            }
          );
        })
        .catch(err => {
          reject(err.response.data.error);
        });
    }),

  [TRANSPORT_REJECT]: (_, data) =>
    new Promise((resolve, reject) => {
      userProfile()
        .then(profile => {
          const userInfo = {
            mailUser: profile?.email ?? null,
            idUser: profile?.id ?? null,
            idPartner: profile?.partnerid ?? null
          };
          const dataToSend = { ...data, ...userInfo };
          transport.transportReject(dataToSend).then(
            () => {
              resolve();
            },
            err => {
              reject(err.response.data.error);
            }
          );
        })
        .catch(err => {
          reject(err.response.data.error);
        });
    }),

  [CANCEL_MANAGEMENT]: (_, { idTransport }) =>
    new Promise((resolve, reject) => {
      transport.cancelManagement({ idTransport }).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data.error);
        }
      );
    }),

  [ACT_SAVE_DATA_TRANSFER]: (params, { data }) =>
    new Promise((resolve, reject) => {
      act.saveActTransfer(data).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [ACT_SAVE_DATA]: (params, { data }) =>
    new Promise((resolve, reject) => {
      act.saveAct(data).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [GET_REQUIRED_DOCUMENTATION]: ({ commit }, { partnerId, patternId }) =>
    new Promise((resolve, reject) => {
      act.catalogByPartnerIdAndStep(partnerId, patternId).then(
        resp => {
          const data = resp.data;
          commit(UI_UPDATE_FROM_PARTNER, { patternId, data });
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [GET_REQUIRED_DOCUMENTATION_OFFLINE]: ({ commit }, { partnerId }) =>
    new Promise((resolve, reject) => {
      act.getRequiredDocumentationOffline(partnerId).then(
        resp => {
          commit(UPDATE_RISK_OFFLINE, { type: 'documents', data: resp.data });
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [GET_REQUIRED_IMAGES_OFFLINE]: ({ commit }, { partnerId }) =>
    new Promise((resolve, reject) => {
      act.getRequiredImagesOffline(partnerId).then(
        resp => {
          commit(UPDATE_RISK_OFFLINE, { type: 'images', data: resp.data });
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [VALIDATE_DOCUMENT]: (params, data) =>
    new Promise((resolve, reject) => {
      act.validateDocument(data).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [CANCEL_ACT]: (params, { transactionId, comment }) =>
    new Promise((resolve, reject) => {
      act.cancelAct(transactionId, comment).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [CANCEL_ACT_TRANSFER]: (params, { transactionId, comment }) =>
    new Promise((resolve, reject) => {
      act.cancelActTransfer(transactionId, comment).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [GET_ID_TRANSACTION_OFFLINE]: (_, { plate }) =>
    new Promise((resolve, reject) => {
      transport.getIdTransactionOffline(plate).then(
        resp => {
          resolve(resp.data);
        },
        err => {
          reject(err.response.data.error);
        }
      );
    }),

  [SAVE_DOCUMENTS_OFFLINE]: (_, { idTransaction, attachmentsDocument }) =>
    new Promise((resolve, reject) => {
      transport.saveDocumentsOffline({ idTransaction, attachmentsDocument }).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data.error);
        }
      );
    }),

  [GET_OFFLINE_PRINT]: () =>
    new Promise((resolve, reject) => {
      transport.getOfflinePrint().then(
        resp => {
          resolve(resp.data);
        },
        err => {
          reject(err.response.data.error);
        }
      );
    })
};
